import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📚 Protocolo 3C completo (12 Tomos)',
  price: 'AR$ 54.990'
}, {
  label: '🎁 Bono #1: Kit Anti-Visto',
  price: 'GRATIS'
}, {
  label: '🎁 Bono #2: Aperturas sin Cringe',
  price: 'GRATIS'
}, {
  label: '🎁 Bono #3: Checklist del Chat',
  price: 'GRATIS'
}, {
  label: '🎁 Bono #4: Guía Express de Cierre',
  price: 'GRATIS'
}, {
  label: '🎁 Bono #5: 7 Errores Necesitado',
  price: 'GRATIS'
}, {
  label: '🛡️ Garantía 7 días',
  price: 'INCLUIDA'
}];
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago · Tarjeta'
}];
export function ValueStack() {
  return <section id="value" aria-label="Resumen de la oferta" className="bg-ink-2 border-y border-white/5" data-id="element-180" data-mp="35ov3uc9utp3j">
      <div className="mx-auto max-w-2xl px-5 py-20 text-center pb-[21px] pt-[32px]" data-id="element-181" data-mp="1tetpebg527we">
        <h2 className="font-display text-2xl font-black text-white sm:text-4xl" data-id="element-182" data-mp="1og9z5yuii9y8">
          🚀 Aplicá el Protocolo 3C y llevá tus chats a una cita concreta
        </h2>

        <div className="mt-10 overflow-hidden rounded-2xl border border-white/10 bg-ink text-left" data-id="element-183" data-mp="236he44lb9au6">
          <div className="flex items-center justify-between border-b border-white/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-white/50" data-id="element-184" data-mp="1ycd2v950igna">
            <span data-id="element-185" data-mp="2850wjv0p44hs">Qué incluye</span>
            <span data-id="element-186" data-mp="283znfw38ps2p">Precio</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-white/5 px-5 py-3.5 text-sm" data-id="element-187" data-mp="2m4ag94o41gqi">
              <span className="text-white/80" data-id="element-188" data-mp="2h5gy2yxvp1k0">{r.label}</span>
              <span className={r.price.startsWith('AR$') ? 'shrink-0 font-bold text-white' : 'shrink-0 font-bold text-gold'} data-id="element-189" data-mp="rphkn5n88pyk">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-wrap items-center justify-between gap-2 bg-azul/10 px-5 py-4" data-id="element-190" data-mp="2mtfoasj2t041">
            <span className="text-sm font-bold text-white" data-id="element-191" data-mp="2rrzc6yh8clz1">
              Valor total real: <span className="text-white/40 line-through" data-id="element-192" data-mp="2ru3jzri9254l">AR$ 101.940</span>
            </span>
            <span className="font-display text-2xl font-black text-gold-shine" data-id="element-193" data-mp="2vw6y6nwazntk">AR$ 19.990</span>
          </div>
        </div>

        <div className="mt-9" data-id="element-194" data-mp="35sjsnnzoa5pd">
          <CTAButton data-id="element-195" data-mp="35r8qfslvl60d">Comprar ahora y empezar hoy</CTAButton>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-196" data-mp="3aqldadcqyd2y">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-197" data-mp="3jjyb9tpo44vw">
              <Icon className="h-4 w-4 text-gold" data-id="element-198" data-mp="3jl9ik3ibnurr" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}